const InputError = ({ error }: { error: string | undefined }) => {
  return (
    <div className="h-1 mb-1">
      {error && (
        <span className="label-text-alt text-[var(--info-red)] font-normal text-xs">
          {error}
        </span>
      )}
    </div>
  );
};

export default InputError;
